import { type AnyFieldApi, useSelector } from "@tanstack/react-form";
import { FormHelperText } from "../../form-fields/form-helper-text";

export const FieldInfo = ({ field, helperText }: { field: AnyFieldApi; helperText?: string }) => {
	const meta = useSelector(field.store, (state) => state.meta);

	if (meta.errors[0]?.message === " ") {
		return null;
	}

	if (meta.errors.length && meta.errors[0].message.length > 0) {
		return <FormHelperText error={true}>{meta.errors[0].message}</FormHelperText>;
	}

	return helperText ? <FormHelperText>{helperText}</FormHelperText> : null;
};
